// Generated by Melange

import * as Cn from "../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(header) {
  return function (children) {
    return function (classNameOpt) {
      const className = classNameOpt !== undefined ? classNameOpt : "bg-white";
      return JsxRuntime.jsxs("div", {
                  children: [
                    header,
                    JsxRuntime.jsx("div", {
                          children: children,
                          className: Cn.fromList({
                                hd: "flex-1 overflow-y-auto flex",
                                tl: {
                                  hd: className,
                                  tl: /* [] */0
                                }
                              })
                        })
                  ],
                  className: Cn.fromList({
                        hd: "grow min-h-screen flex flex-col font-hauss",
                        tl: /* [] */0
                      })
                });
    };
  };
}

function DashboardContentTemplate(Props) {
  return Curry._1(make(Props.header)(Props.children), Props.className);
}

const make$1 = DashboardContentTemplate;

export {
  make$1 as make,
}
/* react/jsx-runtime Not a pure module */
